import { getRequest, patchRequest, postRequest, replaceInUrl } from './index';
import apiEndpoints from './apiEndpoints';

export const authenticateSalesAssistedRequest = (payload) => {
  const { InvitationToken, CustomerEmail } = payload;

  const requestPayload = {
    InvitationToken,
    CustomerEmail,
  };

  return postRequest(
    apiEndpoints.salesAssisted.authenticateUser,
    requestPayload,
  );
};

export const fetchSalesAssistedApplicationsRequiest = (payload) => {
  const { userEmail, brokerCode } = payload;

  const queryParams = {
    userEmail,
    brokerCode,
  };
  return getRequest(apiEndpoints.salesAssisted.fetchApplications, queryParams);
};

export const getUserInfoSalesAssistedRequiest = ({ invitationToken }) =>
  patchRequest(
    replaceInUrl(apiEndpoints.salesAssisted.userInfo, {
      invitationToken,
    }),
  );

export const sendUserInviteSalesAssistedRequiest = ({ ApplicationUid }) => {
  postRequest(
    replaceInUrl(apiEndpoints.salesAssisted.sendInvite, {
      applicationUid: ApplicationUid,
    }),
  );
};

// eslint-disable-next-line arrow-body-style
export const setPasswordRequest = ({ Email, Password }) => {
  return postRequest(apiEndpoints.salesAssisted.setPassword, {
    Email,
    Password,
  });
};
